// @flow

import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { setChatNotificationsHidden } from '../../actions.any';

type Props = {

    /**
     * Redux dispatch function.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Small confirmation dialog asking to hide/do not show chat notifications.
 *
 * @param {Props} props - The props of the component.
 * @returns {React$Element<any>}
 */
function HideNotificationDialog({ dispatch, t }: Props) {
    const onSubmit = () => {
        dispatch(setChatNotificationsHidden(true));

        return true;
    };

    return (
        <Dialog
            okKey = { 'dialog.Yes' }
            onSubmit = { onSubmit }
            titleString = { t('chat.hideChatNotifications', 'Hide chat notifications') }
            width = 'small'>
            <div>
                { t('chat.doNotShowAgain', 'Do not show this message again') }
            </div>
        </Dialog>
    );
}

export default translate(connect()(HideNotificationDialog));
